module.exports = __webpack_public_path__ + "img/xuqiu-side-bg.87a2ae1.png";